"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createInfoNotification = exports.createWarningNotification = exports.createErrorNotification = void 0;

var _v = _interopRequireDefault(require("uuid/v4"));

var _constants = require("./constants");

var _messages = require("./messages");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var UNKNOWN = _constants.errorTypes.UNKNOWN;
var defaultConfig = {
  origin: _constants.ALERT_ORIGIN_FRONTEND
};

var createNotification = function createNotification(message, config) {
  var details = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var notificationParams = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var newConfig = Object.assign({}, defaultConfig, config);
  return _objectSpread(_objectSpread({
    id: (0, _v.default)(),
    type: UNKNOWN,
    severity: _constants.ALERT_TYPE_ERROR,
    time: Date.now(),
    message: message,
    details: details
  }, newConfig), {}, {
    notificationParams: _objectSpread({
      closeButton: false
    }, notificationParams)
  });
};

var createErrorNotification = function createErrorNotification(message, config) {
  var details = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var notificationParams = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return createNotification(message, _objectSpread(_objectSpread({
    title: _messages.messages.inputValidationError.id
  }, config), {}, {
    severity: _constants.ALERT_TYPE_ERROR
  }), details, notificationParams);
};

exports.createErrorNotification = createErrorNotification;

var createWarningNotification = function createWarningNotification(message, config) {
  var details = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var notificationParams = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return createNotification(message, _objectSpread(_objectSpread({
    title: _messages.messages.inputValidationWarning.id
  }, config), {}, {
    severity: _constants.ALERT_TYPE_WARNING
  }), details, notificationParams);
};

exports.createWarningNotification = createWarningNotification;

var createInfoNotification = function createInfoNotification(message, config) {
  var details = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var notificationParams = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return createNotification(message, _objectSpread(_objectSpread({}, config), {}, {
    severity: _constants.ALERT_TYPE_INFO
  }), details, notificationParams);
};

exports.createInfoNotification = createInfoNotification;
//# sourceMappingURL=create-notification.js.map